import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=08016bbc&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"
import style0 from "./Debug.vue?vue&type=style&index=0&id=08016bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08016bbc",
  null
  
)

export default component.exports